(function ($) {
	// Videos 
	if ($('.btn-load-video').length) {
		//$('.btn-open-video').hide();		
		//$('.btn-load-video').each(function (i, obj) {
		$('.btn-load-video').on('click', function (e) {
			e.preventDefault();
			var video = $(this).parent().data('video');
			var iframe = '<iframe width="100%" height="480" src="https://www.youtube-nocookie.com/embed/' + video + '?showinfo=0&fs=0&rel=0&autoplay=1&controls=1" frameborder="0" allowfullscreen></iframe>';
			$(this).parent().append(iframe);
			$(this).fadeOut();
		});
	};
})(jQuery);